/**
 * User Presence Tracking
 *
 * Tracks when users are actively using the app to avoid sending
 * push notifications when they're already seeing in-app notifications.
 *
 * Uses a simple timestamp-based approach:
 * - Client updates presence every 30 seconds while app is focused
 * - Server checks if user was active in the last 60 seconds before sending push
 */

// Enable/disable presence tracking.
// Disabled: the presence-based "skip push while online" gate was removed from
// the push send path because it caused false-negative "I don't get
// notifications" reports (an account looks healthy but pushes are silently
// skipped) and cost a publicProfiles write every 60s per active user. The
// tracking code is left intact so this can be flipped back on if needed.
export const PRESENCE_ENABLED = false;

// How often to update presence (in milliseconds)
export const PRESENCE_UPDATE_INTERVAL = 60 * 1000; // 60 seconds

// How long until a user is considered "offline" (in milliseconds)
export const PRESENCE_TIMEOUT = 120 * 1000; // 120 seconds

/**
 * Check if a timestamp indicates the user is currently online
 */
export function isUserOnline(lastActiveAt: Date | null | undefined): boolean {
  if (!lastActiveAt) return false;

  const now = Date.now();
  const lastActive = lastActiveAt.getTime();

  return now - lastActive < PRESENCE_TIMEOUT;
}
